export default {
  reference_number: "Ref.-Nr",
  article_number: "Art.-Nr.",
};
